export const SHORTCUTS = [
  { id: "custom", label: "Tùy chỉnh" },
  { id: "today", label: "Hôm nay" },
  { id: "yesterday", label: "Hôm qua" },
  { id: "last7Days", label: "7 ngày trước" },
  { id: "last30Days", label: "30 ngày trước" },
  { id: "thisMonth", label: "Tháng này" },
  { id: "lastMonth", label: "Tháng trước" },
  { id: "thisQuarter", label: "Quý này" },
  { id: "lastQuarter", label: "Quý trước" },
];

export const ACTIVE_COLOR = "#1976d2";
export const ACTIVE_BG_COLOR = "rgba(25, 118, 210, 0.12)";
export const CALENDAR_SLIDE_DURATION_MS = 220;
export const DAY_HORIZONTAL_GAP_PX = 2;
export const PRESET_SHORTCUT_IDS = SHORTCUTS.map((item) => item.id).filter((id) => id !== "custom");

